import { unsubscribePlaygamiPush } from "services/push/playgamiPushService";
import { PUSH_LOCAL_STATE_KEY } from "interfaces/pwa";
import { safeLocalStorageSetItem } from "utils/safeLocalStorage";

/**
 * Handle push notification cleanup on user logout.
 * Dessubscribes from push and clears local push state to prevent
 * notification/endpoint leakage to the next user on the same device.
 */
export const handlePushLogout = async (): Promise<void> => {
	void unsubscribePlaygamiPush()
		.then(() => {
			console.log("[Push] Unsubscribed on logout");
		})
		.catch((error) => {
			console.log("[Push] Error unsubscribing on logout", error);
		});

	try {
		safeLocalStorageSetItem(PUSH_LOCAL_STATE_KEY, JSON.stringify(null));
		// console.log("[Push] Cleared local push state on logout");
	} catch (error) {
		// console.log("[Push] Error clearing push state on logout", error);
	}
};
